/*** IMPORTS FROM imports-loader ***/
(function() {
var app = window.app||{};
var define = false;
var exports = false;
var module = undefined;

var app = app || {};

(function ($) {
  'use strict';
  
  /**
   * Вид для страницы торговой марки "Collorista"
   */
  app.ColloristaView = app.View.extend({
    el: '.collorista',
    
    events: {
      'click .js-scroll-link': 'scrollToIdBlock',
      'click .image-link, .news-name': 'renderNewsModal'
    },
    
    run: function () {
      this.addOwlCarousel();
      this.childViews.callMeFormView = new app.ColloristaCallMeFormView({
        el: '.collorista-call-me',
        formName: '.collorista-form',
        initiatorSelector: '.collorista-button'
      });
      this.newsModalTemplate = app.helpers.TemplateHelper.getTemplate('#news-modal-template');
      this.initVideoViews();
    },
    /**
     * Инициализация видео.
     */
    initVideoViews: function () {
      var videoOverview = this.$('.video_overview'),
        that = this;
      _.each(videoOverview, function(video) {
        var id = '#' + video.id;
        that.childViews.colloristaVideoView = new app.ColloristaVideoView({el: id});
        that.childViews.colloristaVideoView.render();
      });
    },
    
    scrollToIdBlock: function (e) {
      e.preventDefault();
      var thisLinkDataId = $(e.currentTarget).data('id'),
        $htmlBody = $('html, body');
      
      if (thisLinkDataId === 'slidetm1') {
        $htmlBody.animate({scrollTop: 0}, 500);
      } else {
        $htmlBody.animate({scrollTop: this.$('#' + thisLinkDataId + '').offset().top}, 500);
      }
    },
    
    addOwlCarousel: function () {
      var owlConfig;
      this.colloristaSlider = this.$('.collorista-chponcki');
      owlConfig = {
        nav: true,
        dots: true,
        items: 1,
        slideBy: 1,
        loop: true,
        responsiveClass: true,
        autoplay: true,
        autoplayTimeout: 5000,
        autoplaySpeed: 1000,
        autoplayHoverPause: true
      };
      this.colloristaSlider.owlCarousel(owlConfig);
      this.colloristaSliderLookbook = this.$('.lookbook-slider');
      owlConfig = {
        nav: true,
        dots: false,
        items: 1,
        slideBy: 1,
        loop: true,
        autoplay: false
      };
      this.colloristaSliderLookbook.owlCarousel(owlConfig);
      this.colloristaCatalogSlider = this.$('.collorista-catalog-slider');
      owlConfig = {
        nav: true,
        dots: false,
        items: 3,
        slideBy: 1,
        loop: true,
        autoplay: false
      };
      this.colloristaCatalogSlider.owlCarousel(owlConfig);
      this.colloristaNewsSlider = this.$('.collorista-news-slider');
      owlConfig = {
        nav: true,
        dots: false,
        items: 2,
        slideBy: 1,
        loop: true,
        autoplay: false
      };
      this.colloristaNewsSlider.owlCarousel(owlConfig);
    },
    renderNewsModal: function (e) {
      var id = $(e.currentTarget).data('id'),
        that = this;
      this.newsMainModel = new app.NewsArticle();
      this.newsMainModel.set('id', id);
      this.newsMainModel.fetch({
        success: function (model) {
          var created = app.helpers.DateHelper.asSocialDate(model.get('published_at'), 'DD.MM.YYYY');
          $('.collorista-modal-news .one-new-description').html(that.newsModalTemplate({
            newsMain: model.toJSON(),
            created: created
          }));
        }
      });
    }
  });
})(jQuery);

}.call(window));